import { render, staticRenderFns } from "./caseDetail.vue?vue&type=template&id=3c90f588&scoped=true&"
import script from "./caseDetail.vue?vue&type=script&lang=js&"
export * from "./caseDetail.vue?vue&type=script&lang=js&"
import style0 from "./caseDetail.vue?vue&type=style&index=0&id=3c90f588&scoped=true&lang=css&"
import style1 from "./caseDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90f588",
  null
  
)

export default component.exports